import { Atom } from ":mods";
import { createSignal, splitProps } from "solid-js";
import { NationalityViewProps } from "./model";

export function Nationality(props:NationalityViewProps) {
  const [local, others] = splitProps(props, ["data"]);
  const radioContainerStyle = "flex gap-10px border border-2 border#p border-solid p-20px";
  const dropdownContainerStyle = "flex justify-between border border-2 border#p border-solid p-15px";
  const [moduleOpen, setModuleOpen] = createSignal(false);
  const handleAccordionClicks = () => {
    setModuleOpen(moduleOpen()?false:true);
  };
  return (
    <Atom.Foldable.Accordion
      arrowMode="end"
      iconClass={`w-24px h-24px  icon-local:down-arrow ${moduleOpen() && "!rotate-180"}`}
      onclick={handleAccordionClicks}
      title={
        <section class="flex flex-row justify-start items-center w-full font-700">
          <span>Nationality (Foundation Sign Up)</span>
        </section>
      }
      class="border-2 border-solid border#p px-2 py-20px mb-20px"
    >
      <section class="flex flex-col gap-20px mt-40px">
        <div class="flex flex-col gap-10px">
          <p class="text-16px leading-22.4px">Saudi Citizen</p>
          <div class={radioContainerStyle}>
            <input type="radio" readOnly checked={local.data.saudi_citizen} class={"w-25px h-25px cursor-pointer"} />
            <p>Yes</p>
          </div>
          <div class={radioContainerStyle}>
            <input type="radio" readOnly checked={!local.data.saudi_citizen} class={"w-25px h-25px cursor-pointer"} />
            <p>No</p>
          </div>
        </div>

        <div class="flex flex-col gap-10px">
          <p class="text-16px leading-22.4px">Are you a Saudi Resident? :</p>
          <div class={radioContainerStyle}>
            <input type="radio" readOnly checked={local.data.saudi_resident} class={"w-25px h-25px cursor-pointer"} />
            <p>Yes</p>
          </div>
          <div class={radioContainerStyle}>
            <input type="radio" readOnly checked={!local.data.saudi_resident} class={"w-25px h-25px cursor-pointer"} />
            <p>No</p>
          </div>
        </div>
        <div class="flex flex-col gap-10px">
          <p>Which region are you living? :</p>
          <div class={dropdownContainerStyle}>
            <p>{local.data?.region || ""}</p>
            <i class="icon-local:down-arrow w-25px h-25px" />
          </div>
        </div>
      </section>
    </Atom.Foldable.Accordion>
  );
}
